import { render, staticRenderFns } from "./SpecialDayAssistance.vue?vue&type=template&id=17cb629a"
import script from "./SpecialDayAssistance.vue?vue&type=script&lang=js"
export * from "./SpecialDayAssistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports